import { Injectable } from '@angular/core';
import { CanLoad, Router, Route, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { EsriAuthService } from '../services/esri-auth.service';

@Injectable({
  providedIn: 'root'
})
export class LandingAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    // tslint:disable-next-line: variable-name
    private esriAuth: EsriAuthService
  ) {}

  // async canActivate() {
  //     // return true;
  //   return this.esriAuth.checkSignIn().then(isSignedIn => {
  //     if (isSignedIn) {
  //       this.esriAuth.signIn().then(() => {
  //         this.router.navigateByUrl('/home');
  //       });
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   });
  // }

  async canActivate() {
    return this.esriAuth.checkSignIn().then(isSignedIn => {
      const enteredCredentials = sessionStorage.getItem('EnteredCredentials') === 'true';
      const authFailed = this.esriAuth.didAuthFail();
      if (isSignedIn || (enteredCredentials && !authFailed)) {
        this.esriAuth.signIn().then(() => {
          this.router.navigateByUrl('/home');
          return false;
        });
      } else {
        return true;
      }
    });
  }
}
